<template>
  <div
    class="unit-details"
    :class="
      isUnitResultsExpanded && expanded
        ? 'disappear'
        : !isUnitResultsExpanded
        ? 'unit-name-price-container'
        : ''
    "
  >
    <div style="margin-bottom: 5px">
      <button
        @click="interestedClicked(unit)"
        class="semi-bold interest-btn"
        :class="interested ? 'interest-btn-clicked' : ''"
      >
        <span v-show="!interested">I am Interested</span>
        <img
          v-show="interested"
          src="../../assets/check_mark.svg"
        />
        <span v-show="interested">Interested</span>
      </button>
    </div>
    <table>
      <tbody>
        <tr v-if="unit.manufacturer">
          <td class="semi-bold unit-param">Manuf.</td>
          <td class="primary-reg">{{ unit.manufacturer }}</td>
        </tr>
        <tr>
          <td class="semi-bold unit-param">Brand</td>
          <td class="primary-reg">{{ unit.brand }}</td>
        </tr>
        <tr>
          <td class="semi-bold unit-param">Floorplan</td>
          <td class="primary-reg">{{ unit.floorplan }}</td>
        </tr>
        <tr v-if="typeof unit.sale_price === 'number' || typeof unit.price === 'number'">
          <td class="semi-bold unit-param">Price</td>
          <td class="primary-reg">{{ formatCurrency(unit.sale_price) || formatCurrency(unit.price) }}</td>
        </tr>
        <tr>
          <td class="semi-bold unit-param">Year</td>
          <td class="primary-reg">{{ unit.year }}</td>
        </tr>
        <tr v-if="unit.condition != 'new' && unit.mileage">
          <td class="semi-bold unit-param">Mileage</td>
          <td class="primary-reg">
            {{ unit.mileage?.toLocaleString("en-US") }}
          </td>
        </tr>
        <tr>
          <td class="semi-bold unit-param">Type</td>
          <td class="primary-reg">{{ unit.type }}</td>
        </tr>
        <tr v-if="unit.sleep_capacity">
          <td class="semi-bold unit-param">Sleeps</td>
          <td class="primary-reg">{{ unit.sleep_capacity }}</td>
        </tr>
        <tr>
          <td class="semi-bold unit-param">Location</td>
          <td class="primary-reg">{{ unit.location }}</td>
        </tr>
      </tbody>
    </table>
    <div style="text-align: center">
      <a class="primary-reg" :href="unit.link" target="_blank">More info</a>
    </div>
  </div>
</template>

<script setup>
import { useSearchResultsStore } from '@/stores/useSearchResultsStore';

defineProps({
  unit: { type: Object, required: true },
  interested: {type: Boolean, required: false, default: false},
  isUnitResultsExpanded: { type: Boolean, required: false, default: true },
  expanded: { type: Boolean, required: false, default: false },
});

const { toggleUnitInterest } = useSearchResultsStore();

/**
 * toggle whether or not the user is interesed in this unit
 * @param {object} unit
 */
 function interestedClicked(unit) {
  toggleUnitInterest(unit);
}

/**
 * Add $ and , to currency value
 * @param {number} value
 */
 function formatCurrency(value) {
  if (typeof value != 'number') return null;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

/**
 * Capitalize the first letter of a string
 * @param {string} str
 */
// function capitalizeFirstLetter(str) {
//   if (!str) return '';
//   return str.charAt(0).toUpperCase() + str.slice(1);
// }
</script>

<style>
.unit-details {
  width: 186px;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 15px 10px 10px 15px;
  box-sizing: border-box;
  opacity: 1;
  transition: opacity 0.25s ease-out;
  z-index: 1;
  background-color: white;
}

.unit-details::-webkit-scrollbar {
  display: none;
}

.unit-details table {
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
}

.unit-details td {
  vertical-align: top;
}

.disappear {
  opacity: 0 !important;
}

.interest-btn {
  background-color: var(--black-default);
  border-radius: 4px;
  color: var(--white-dark);
  border: none;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  box-sizing: border-box;
  border: 0.5px solid var(--black-default);
  display: flex;
  align-items: center;
  justify-content: center;
}

.interest-btn img {
  margin-right: 10px;
}

.interest-btn-clicked {
  color: var(--black-default);
  background-color: var(--white-dark);
  border: 0.5px solid var(--primary-accent-base);
}

.primary-reg {
  color: var(--black-default);
  text-align: left;
}

.unit-param {
  color: var(--black-default);
  text-align: left;
}

button {
  font-family: "Roboto", sans-serif;
}
</style>